import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AppContext";
import { toast } from "sonner";
import { LOGO_URL } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setSessionUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { nav("/login", { replace: true }); return; }

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/session-exchange",
          { session_id: sessionId },
          { withCredentials: true, headers: { "X-Session-ID": sessionId } }
        );
        setSessionUser(data);
        // clear the hash and go to account
        window.history.replaceState({}, document.title, window.location.pathname);
        nav("/account", { replace: true, state: { user: data } });
        toast.success(`Welcome, ${data.name?.split(" ")[0] || "friend"}`);
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        nav("/login", { replace: true });
      }
    })();
  }, [location.hash, nav, setSessionUser]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-6">
      <img src={LOGO_URL} alt="ASURE" className="h-14 animate-pulse" />
      <div className="font-display text-2xl text-asure-forest">Signing you in…</div>
      <div className="text-sm text-asure-text2">Setting up your ASURE account</div>
    </div>
  );
}
